<template>
  <div></div>
</template>

<script>
export default {
  name: 'jenkins',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
